module.exports = __webpack_public_path__ + "media/_/_/node_modules/gateway_web_console/app/assets/images/light_blue_theme-385ed5485df060ecd75457fb696ab4d2.png";